// ============================================================
// Einklappbare Filter-Bereiche in der Shop-Sidebar (Feelgood-only)
// ============================================================
// Die Webshop-Templates rendern jeden Filter-Bereich offen. Auf Feelgood
// starten die Bereiche ZUGEKLAPPT - ausgenommen der Artikelgruppen-Baum
// ("Alle Artikelgruppen"), der offen bleibt (Kundenwunsch 2026-10-16).
//
// Pfeile: dieselben Text-Glyphen wie die PFeile der Feelgood-Theme-JS
// (&#9660; offen / &#9654; zu). Bei den Label-Bereichen (Farbe/Groesse/
// Sachmerkmal) sitzen sie rechts in der Kopfzeile, beim Artikelgruppen-Baum
// in der Einrueckungs-Spalte links von "Alle Artikelgruppen".
//
// Besonderheit Artikelgruppen-Baum: die Feelgood-Theme-JS (Website Theme
// "Standard", /website_script.js) blendet das Label "Artikelgruppe" aus,
// haengt an jeden Ast ihren eigenen Pfeil in die Einrueckungs-Spalte und
// faltet Aeste. Der DOM des Baums bleibt hier unveraendert (nur Klasse +
// Pfeil), damit die Theme-JS weiter mit Kindknoten/Leveln arbeiten kann.
//
// Ausgangs-Markup (unveraendert):
//   .filter-block
//     .filter-label.mb-3              Titel (Attribut / Feld / Verfuegbarkeit)
//     input.filter-lookup-input       optionale Suche (>20 Werte)
//     .filter-options                 Werte
//   Sachmerkmale (erstes Label ist per CSS ausgeblendet):
//   .filter-block
//     div.pb-1
//       .second-specification-filter-label    Merkmalname (z.B. GESCHLECHT)
//       .filter-options
//
// Nach dem Umbau (ausser beim Baum):
//   <button.ws-collapse-header>  Titel + Pfeil  </button>
//   <div.ws-collapse-body>       bisheriger Inhalt </div>
//
// Der Zustand liegt in localStorage, Schluessel = Bereichs-Prefix + Titeltext.

(() => {
	const CARD = "#product-filters";
	const STORAGE_KEY = "fg_shop_filter_collapsed";
	const TREE_KEY = "tree:artikelgruppen";

	const CARET_OPEN = "&#9660;"; // ▼
	const CARET_CLOSED = "&#9654;"; // ▶

	const state = read_state();

	function read_state() {
		try {
			return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
		} catch (e) {
			return {};
		}
	}

	function write_state() {
		try {
			localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
		} catch (e) {
			// localStorage kann fehlen (Private Mode) - dann merkt sich die
			// Seite den Zustand eben nur bis zum naechsten Reload.
		}
	}

	function collapse_key(title) {
		return (title || "").trim().toLowerCase().replace(/\s+/g, " ");
	}

	function level_of(node) {
		const match = /--item-group-level:\s*(\d+)/.exec(node.getAttribute("style") || "");
		return match ? parseInt(match[1], 10) : 0;
	}

	function label(english, german) {
		return window.__ ? __(english) : german;
	}

	// Baut aus $container einen einklappbaren Bereich. $title bleibt das
	// originale Label-Element, damit die bestehende .filter-label-Optik greift.
	function make_collapsible($container, $title, prefix, default_collapsed) {
		const key = prefix + ":" + collapse_key($title.text());
		const $body = $('<div class="ws-collapse-body"></div>');

		// Alles ausser dem Titel wandert in den Body ...
		$container.children().not($title).appendTo($body);
		$container.append($body);

		// ... und der Titel + Pfeil in den Umschalter.
		const $header = $(
			'<button type="button" class="ws-collapse-header" aria-expanded="true"></button>'
		);
		const $caret = $('<span class="ws-collapse-caret" aria-hidden="true"></span>');
		$header.append($title).append($caret);
		$container.prepend($header);

		function apply(collapsed) {
			$header.attr("aria-expanded", collapsed ? "false" : "true");
			$caret.html(collapsed ? CARET_CLOSED : CARET_OPEN);
			$container.toggleClass("ws-collapsed", collapsed);
		}

		apply(state[key] === undefined ? !!default_collapsed : !!state[key]);

		$header.on("click", () => {
			const collapsed = !$container.hasClass("ws-collapsed");
			apply(collapsed);
			state[key] = collapsed;
			write_state();
		});
	}

	// Artikelgruppen-Baum: Pfeil in der Einrueckungs-Spalte der Wurzelzeile;
	// gefaltet wird ueber eine Klasse am Block.
	function setup_tree_block($block) {
		$block.addClass("ws-tree-block");

		const $root_node = $block
			.find(".item-group-filter-node")
			.filter((i, node) => level_of(node) === 0)
			.first();
		if (!$root_node.length) return;

		const $root_line = $root_node.children(".item-group-filter-header").first();
		if (!$root_line.length) return;

		$root_node.addClass("ws-tree-root");

		const $caret = $(
			'<button type="button" class="ws-collapse-caret-gutter" aria-expanded="true"></button>'
		);
		$root_line.prepend($caret);

		function apply(collapsed) {
			$caret.html(collapsed ? CARET_CLOSED : CARET_OPEN);
			$caret.attr("aria-expanded", collapsed ? "false" : "true");
			$caret.attr(
				"title",
				collapsed ? label("Expand", "Aufklappen") : label("Collapse", "Zuklappen")
			);
			$block.toggleClass("ws-collapsed", collapsed);
		}

		apply(state[TREE_KEY] === undefined ? false : !!state[TREE_KEY]);

		$caret.on("click", (event) => {
			event.preventDefault();
			event.stopPropagation();
			const collapsed = !$block.hasClass("ws-collapsed");
			apply(collapsed);
			state[TREE_KEY] = collapsed;
			write_state();
		});
	}

	function process_block(block) {
		const $block = $(block);
		if ($block.data("ws-collapse-ready")) return;
		$block.data("ws-collapse-ready", true);

		// Artikelgruppen-Baum (Feld-Filter "item_group") - offen, Pfeil am Wurzelknoten
		if ($block.find(".item-group-filter-node").length) {
			setup_tree_block($block);
			return;
		}

		// Sachmerkmale: das Label der Specification-Vorlage ist auf Feelgood
		// per CSS ausgeblendet, sichtbar und damit einklappbar ist jedes
		// einzelne Merkmal. Standard: zugeklappt.
		const $spec_rows = $block
			.children("div.pb-1")
			.filter((i, el) => $(el).children(".second-specification-filter-label").length > 0);

		if ($block.children(".first-specification-filter-label").length && $spec_rows.length) {
			$spec_rows.each((i, el) => {
				const $row = $(el);
				make_collapsible(
					$row,
					$row.children(".second-specification-filter-label").first(),
					"spec",
					true
				);
			});
			return;
		}

		// Attribut-, Feld- und Verfuegbarkeits-Filter: ein Bereich je Label,
		// Standard zugeklappt.
		const $lbl = $block.children(".filter-label").first();
		if (!$lbl.length) return;
		make_collapsible($block, $lbl, "section", true);
	}

	function init() {
		const $card = $(CARD);
		if (!$card.length) return;

		$card.find(".filter-block").each((i, el) => process_block(el));

		// Der Rabatt-Filter wird vom Webshop-JS erst nach der Listing-Antwort
		// angehaengt - neue Bereiche also nachtragen.
		if (window.MutationObserver) {
			new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					$(mutation.addedNodes)
						.find(".filter-block")
						.addBack(".filter-block")
						.each((i, el) => process_block(el));
				});
			}).observe($card.get(0), { childList: true });
		}
	}

	if (window.jQuery && window.frappe && frappe.ready) {
		frappe.ready(init);
	} else if (window.jQuery) {
		$(init);
	}
})();
